import { tabs } from '@entities/events/lib';
import cn from 'classnames';
import { useEffect } from 'react';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { useAppDispatch, useAppSelector } from 'library/hooks/common';
import { resetEvents, selectTab, setSelectedTab } from 'library/redux/events';
import * as st from './styles.module.scss';

export const Tabs = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const tab = useAppSelector(selectTab);
  const { permissions } = useModuleByCodeParam();

  const onTabChange = (tab: string) => {
    dispatch(resetEvents());
    dispatch(setSelectedTab(tab));
  };

  useEffect(() => {
    if (permissions.can_sell) {
      dispatch(resetEvents());
      dispatch(setSelectedTab(tabs['all'].code));
    }
  }, [permissions.can_sell, dispatch]);

  return (
    <>
      <button
        className={cn(st.tab, tab.code === 'all' && st.active)}
        onClick={() => onTabChange(tabs['all'].code)}
      >
        {tabs['all'].title}
      </button>
      {permissions.can_buy && (
        <button
          className={cn(st.tab, tab.code === 'rental' && st.active)}
          onClick={() => onTabChange(tabs['rental'].code)}
        >
          {tabs['rental'].title}
        </button>
      )}
      {permissions.can_sell && (
        <button
          className={cn(st.tab, tab.code === 'my' && st.active)}
          onClick={() => onTabChange(tabs['my'].code)}
        >
          {tabs['my'].title}
        </button>
      )}
    </>
  );
};
